var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxMoreVert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 18C12.661 18 13.2012 18.5402 13.2012 19.2002C13.2011 19.8601 12.6609 20.4004 12.001 20.4004C11.341 20.4004 10.8009 19.8601 10.8008 19.2002C10.8008 18.5402 11.341 18 12.001 18ZM12.001 10.7998C12.661 10.7998 13.2012 11.34 13.2012 12C13.2012 12.66 12.661 13.2002 12.001 13.2002C11.341 13.2002 10.8008 12.66 10.8008 12C10.8008 11.34 11.341 10.7998 12.001 10.7998ZM12.001 3.59961C12.6609 3.59961 13.2011 4.13989 13.2012 4.7998C13.2012 5.4598 12.661 6 12.001 6C11.341 6 10.8008 5.4598 10.8008 4.7998C10.8009 4.13989 11.341 3.59961 12.001 3.59961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxMoreVert);
export default __webpack_public_path__ + "static/media/icon_24px_more-vert.2db7bb41c34ea73e7a0316d5ea372d70.svg";
export { ForwardRef as ReactComponent };